import { render, staticRenderFns } from "./DownloadApp.vue?vue&type=template&id=25561e61&scoped=true&"
import script from "./DownloadApp.vue?vue&type=script&lang=ts&"
export * from "./DownloadApp.vue?vue&type=script&lang=ts&"
import style0 from "./DownloadApp.vue?vue&type=style&index=0&id=25561e61&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25561e61",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VImg } from 'vuetify/lib/components/VImg';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VIcon,VImg,VRow})
